import React, { useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';

import Arrow from 'apps/web_forms/assets/arrow.svg';
import { COLORS } from 'apps/web_forms/utils/constants';
import useGlobalSelector from 'apps/web_forms/hooks/useGlobalSelector';

const StyledArrow = styled(Arrow)`
  margin: 0 6px;
`;

const RightArrow = () => <StyledArrow transform={'scale(-0.6, 0.6)'} />;

const VerticallyCenteredFlex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  &:disabled {
    cursor: default !important;
    background: ${COLORS.disabledInputBackgroundColor};
    border: ${COLORS.disabledInputBackgroundColor};
  }
`;

/**
 * @returns {JSX.Element}
 */
const IssuesFoundButton = () => {
  const { fieldResourceUpdateHighlights } = useGlobalSelector();

  const remainingAffectedFields = useMemo(() => {
    return Object.entries(fieldResourceUpdateHighlights).filter(
      ([_identifier, isHighlighted]) => !!isHighlighted
    ).length;
  }, [fieldResourceUpdateHighlights]);

  const [
    currentlyScrolledResourceHighlightedField,
    setCurrentlyScrolledResourceHighlightedField,
  ] = useState();
  const [nextField, setNextField] = useState();

  const scrollToNextResourceHighlightedField = useCallback(() => {
    const currentlyHighlightedFieldIdentifers = Object.keys(
      fieldResourceUpdateHighlights
    ).filter((key) => !!fieldResourceUpdateHighlights[key]);
    const domElements = currentlyHighlightedFieldIdentifers.map((identifier) =>
      document.getElementById(identifier)
    );
    const domElementsInOrder = sortedByDomOrder(domElements);
    const currentIndex = !currentlyScrolledResourceHighlightedField
      ? nextField ?? -1
      : domElementsInOrder.findIndex(
          (element) => element.identifier === currentlyScrolledResourceHighlightedField
        );
    const indexToScrollTo = safeNextIndex(currentIndex, domElementsInOrder);
    const elementToScrollTo = domElementsInOrder[indexToScrollTo];
    const nextIndexToScrollTo = safeNextIndex(
      indexToScrollTo,
      domElementsInOrder
    );
    if(!elementToScrollTo) return;
    const newNextField = domElementsInOrder[nextIndexToScrollTo].id;
    scrollTo(elementToScrollTo);
    setCurrentlyScrolledResourceHighlightedField(elementToScrollTo.id);
    setNextField(newNextField);
  }, [
    currentlyScrolledResourceHighlightedField,
    fieldResourceUpdateHighlights,
  ]);
  const pluralization = remainingAffectedFields > 1 ? 's' : '';

  return (
    <VerticallyCenteredFlex
      role='button'
      onClick={scrollToNextResourceHighlightedField}
    >
      {`${remainingAffectedFields} issue${pluralization} found `}
      <RightArrow />
    </VerticallyCenteredFlex>
  );
};

IssuesFoundButton.propTypes = {};

IssuesFoundButton.defaultProps = {};

/**
 * @param {number} index
 * @param {Array} array
 */
const safeNextIndex = (index, array) => {
  return index + 1 <= array.length - 1 ? index + 1 : 0;
};

/**
 * @param {HTMLElement[]} elements
 */
const sortedByDomOrder = (elements) => {
  return [...elements].sort(
    (a, b) =>
      a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1 // eslint-disable-line no-bitwise
  );
};

/**
 * @param {HTMLElement} element
 * @returns {HTMLElement}
 */
const createOffsetElement = (element) => {
  const offsetElement = document.createElement('div');
  offsetElement.style = `
    position: relative;
    top: -10em;
    height: 1px;
    width: 1px;
    visibility: hidden;
  `;
  const inputWrapper = element.closest('.react-form-control');
  inputWrapper.appendChild(offsetElement);
  return offsetElement;
};

/**
 * @param {HTMLElement} element
 */
const scrollTo = (element) => {
  const offsetElement = createOffsetElement(element); // Is it a hack? Yes. Does it work? Yes.
  offsetElement.scrollIntoView({
    behavior: 'smooth',
  });
  offsetElement.remove();
};

export { IssuesFoundButton };
export default IssuesFoundButton;
